import { Cursors, DRAG, DRAG_END, DRAG_START, HANDLE_NAMES } from './../../constants';
import { canDrag } from './canDrag';
export class ConnectionEditTool {
    constructor(toolService) {
        this.toolService = toolService;
        this.type = 'ConnectionTool';
    }
    tryActivate(_p, meta) {
        const toolService = this.toolService, diagram = toolService.diagram, selectable = diagram.options.selectable, item = toolService.hoveredItem, isActive = selectable !== false &&
            item && item.path && !(item.isSelected && meta.ctrlKey);
        if (isActive) {
            this._c = item;
        }
        return isActive;
    }
    start(point, meta, nativeEvent) {
        const toolService = this.toolService;
        const connection = this._c;
        toolService.selectSingle(connection, meta);
        const adorner = connection.adorner;
        let handle, name;
        if (adorner) {
            handle = adorner._hitTest(point);
            name = HANDLE_NAMES[handle];
        }
        if (canDrag(connection) && adorner && !toolService.diagram.trigger(DRAG_START, { shapes: [], connections: [connection], connectionHandle: name, point, meta, nativeEvent })) {
            this.handle = handle;
            this.handleName = name;
            adorner.start(point);
        }
        else {
            toolService.startPoint = point;
            toolService.end(point, meta, nativeEvent);
        }
    }
    move(point, meta, nativeEvent) {
        const adorner = this._c.adorner;
        if (canDrag(this._c) && adorner) {
            adorner.move(this.handle, point);
            this.toolService.diagram.trigger(DRAG, { shapes: [], connections: [this._c], connectionHandle: this.handleName, point, meta, nativeEvent });
            return true;
        }
    }
    end(point, meta, nativeEvent) {
        const connection = this._c;
        const adorner = connection.adorner;
        const toolService = this.toolService;
        const diagram = toolService.diagram;
        if (adorner) {
            if (canDrag(connection)) {
                const unit = adorner.stop(point);
                if (!diagram.trigger(DRAG_END, { shapes: [], connections: [connection], connectionHandle: this.handleName, point, meta, nativeEvent })) {
                    diagram.undoRedoService.add(unit, false);
                    connection.updateModel();
                    diagram._syncConnectionChanges();
                }
                else {
                    unit.undo();
                }
            }
        }
    }
    getCursor() {
        return Cursors.move;
    }
}
